<template>
  <v-list nav dense class="employee-menu">
    <v-list-group
      v-for="section in employeeMenuSections"
      :key="section.title"
      :prepend-icon="section.icon"
      :value="isSectionActive(section.items)"
      no-action
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>{{ section.title }}</v-list-item-title>
        </v-list-item-content>
      </template>

      <v-list-item
        v-for="item in section.items"
        :key="item.to"
        link
        router
        :to="item.to"
        class="list"
        active-class="menu-item-active"
      >
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EmployeeMenu',
  computed: {
    ...mapGetters(['getProfile']),
    userPermissions () {
      const profile = this.getProfile || {}
      const raw = profile.permissions || profile.employee_permissions || []
      const list = []

      if (Array.isArray(raw)) {
        raw.forEach(p => {
          if (typeof p === 'string') {
            const val = p.toLowerCase().trim()
            if (val && !list.includes(val)) list.push(val)
          } else if (p && typeof p === 'object') {
            const val = (p.permission || p.value || p.name || p.code || '').toLowerCase().trim()
            if (val && !list.includes(val)) list.push(val)
          }
        })
      }

      return list
    },
    employeeMenuSections () {
      const sections = [
        {
          title: 'Oficina',
          icon: 'mdi-office-building-outline',
          items: [
            { to: '/oficina/dashboard', icon: 'mdi-view-dashboard-outline', title: 'Dashboard', visible: true },
            { to: '/oficina/cuotas', icon: 'mdi-receipt-text-outline', title: 'Cuotas', visible: this.hasPermission('fees') },
            { to: '/oficina/usuarios', icon: 'mdi-account-tie-outline', title: 'Usuarios de Oficina', visible: this.hasPermission('employees') },
            { to: '/oficina/empleados', icon: 'mdi-badge-account-outline', title: 'Accesos de empleados', visible: this.hasPermission('employees') },
            { to: '/oficina/invitaciones', icon: 'mdi-send', title: 'Invitaciones de oficina', visible: this.hasPermission('invitations') },
            { to: '/oficina/areas', icon: 'mdi-office-building-cog-outline', title: 'Áreas de oficina', visible: this.hasPermission('areas') },
            { to: '/oficina/reportes', icon: 'mdi-chart-box-outline', title: 'Reportes administrativos', visible: this.hasPermission('fees') || this.hasPermission('employees') }
          ]
        },
        {
          title: 'Residentes y viviendas',
          icon: 'mdi-home-account',
          visible: this.hasPermission('residents'),
          items: [
            { to: '/casas', icon: 'mdi-home-variant', title: this.$t('casas') || 'Casas', visible: true },
            { to: '/directory', icon: 'mdi-bookmark-box-multiple', title: this.$t('directory') || 'Directorio', visible: true },
            { to: '/main_residents', icon: 'mdi-account-star', title: this.$t('residentes') || 'Residentes', visible: true }
          ]
        },
        {
          title: 'Accesos y visitas',
          icon: 'mdi-account-arrow-right-outline',
          visible: this.hasPermission('invitations'),
          items: [
            { to: '/current_invitations', icon: 'mdi-calendar-multiselect', title: this.$t('current_invitations') || 'Invitaciones actuales', visible: true }
          ]
        },
        {
          title: 'Servicios y finanzas',
          icon: 'mdi-cash-multiple',
          visible: this.hasPermission('fees'),
          items: [
            { to: '/account_statements', icon: 'mdi-account-cash', title: this.$t('account_statements') || 'Estados de cuenta', visible: true }
          ]
        },
        {
          title: 'Configuracion y ayuda',
          icon: 'mdi-cog-outline',
          items: [
            { to: '/settings', icon: 'mdi-cog-outline', title: this.$t('configuracion') || 'Configuración', visible: true },
            { to: '/ayuda', icon: 'mdi-help-circle', title: this.$t('Ayuda') || 'Ayuda', visible: true }
          ]
        }
      ]

      return sections
        .filter((section) => section.visible !== false)
        .map((section) => ({
          ...section,
          items: section.items.filter((item) => item.visible !== false)
        }))
        .filter((section) => section.items.length > 0)
    }
  },
  methods: {
    hasPermission (code) {
      if (!code) return false
      return this.userPermissions.includes(code.toLowerCase())
    },
    isSectionActive (items) {
      if (!this.$route || !this.$route.path) {
        return false
      }

      return items.some((item) => this.$route.path === item.to || this.$route.path.startsWith(`${item.to}/`))
    }
  }
}
</script>

<style scoped>
.list:hover {
  background: rgba(255, 255, 255, 0.14);
  opacity: 1;
}

.employee-menu ::v-deep .v-list-group__header {
  min-height: 40px;
  border-left: 4px solid transparent;
  border-radius: 0 10px 10px 0;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.employee-menu ::v-deep .v-list-group__header:hover {
  background: rgba(255, 255, 255, 0.12);
}

.employee-menu ::v-deep .v-list-group--active > .v-list-group__header {
  background: rgba(255, 255, 255, 0.2) !important;
  border-left-color: #43a047;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.18);
}

.employee-menu ::v-deep .v-list-group--active > .v-list-group__header .v-list-item__title {
  color: #ffffff !important;
  font-weight: 700;
}

.employee-menu ::v-deep .v-list-group--active > .v-list-group__header .v-icon {
  color: #a5d6a7 !important;
}

.employee-menu ::v-deep .menu-item-active {
  background: rgba(255, 255, 255, 0.2) !important;
  border-left: 4px solid #43a047;
  border-radius: 0 10px 10px 0;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.18);
}

.employee-menu ::v-deep .menu-item-active .v-list-item__title {
  color: #ffffff !important;
  font-weight: 700;
}

.employee-menu ::v-deep .menu-item-active .v-icon {
  color: #a5d6a7 !important;
}
</style>
